<div class="panel-body " *ngIf="dispositionDelinquentOffense===undefined">
  <div class="col-md-12 panel panel-default panel-margin-bottom panel-margin-top">
      <div class="panel-title">
        Disposition Result
      </div>
      <div class="panel-body ">
        No Disposition Result information available for this allegation.
      </div>
  </div>
</div>
<div class="panel-body " *ngIf="dispositionDelinquentOffense!==undefined">
    <div class="col-md-12 panel panel-default panel-margin-bottom panel-margin-top">
     <div class="panel-title">
      Disposition Result
       </div>
     <div class="panel-body ">
         <div class="col-md-6 panel panel-default">
           <div class="panel panel-default " *ngIf="dispositionDelinquentOffense.getDispositionDate() !== ''">
           <div class="panel-title">
            Disposition Date
           </div>
           <div class="panel-body">
               {{dispositionDelinquentOffense.getDispositionDate()}}
           </div>
           </div>
           <div class="panel panel-default " *ngIf="dispositionDelinquentOffense.getParents().length !==0">
           <div class="panel-title">
                 Parent/Guardian/Custodian Assigned
           </div>
           <div class="panel-body" *ngFor="let parent of dispositionDelinquentOffense.getParents(); let al = index">
                 {{parent.getPartyName()+ ' (' + parent.getRelationship() + ')'}}
           </div>
           </div>
         </div>
         <div class="col-sm-6 panel panel-default ">
           <div class="panel panel-default " *ngIf="dispositionDelinquentOffense.getDispositionEoDate() !== ''">
           <div class="panel-title">
            Disposition EO Date
           </div>
           <div class="panel-body">
               {{dispositionDelinquentOffense.getDispositionEoDate()}}
           </div>
           </div>
         </div>
         </div>
         <div class="panel panel-default" *ngIf="dispositionDelinquentOffense.getOtherAllegations().length !=0">
            <div class="panel-title">
              Other Allegations Included On Order
            </div>
            <div class="panel-body">
                <div class="row table-responsive">
                    <table id="allegations-table" class="table table-condensed table-striped">
                        <thead>
                            <tr>
                                <th id="V122c">
                                  <span class="field-code ">V122c json='allegations.pleadingType'</span>
                                  Pleading Type <br> 
                                  <span class="field-code ">V122c json='allegations.clockDate'</span>
                                  And Clock Date
                                </th>
                                <th id="V121c">
                                  <span class="field-code ">V121c json='allegations.allegation'</span>
                                    Allegation <br>
                                    <span class="field-code ">V121c json='allegations.offenseDate'</span>
                                    Offense Date
                                  </th>
                                 </tr>
                        </thead>
                        <tbody  *ngFor="let otherAllegation of dispositionDelinquentOffense.getOtherAllegations()let i = index;">                            
                          <tr >
                           <td id="{{'juvenile-caseDetails-dispositionDelinquentOffense-' + i + '-pleadingType'}}">
                             {{otherAllegation.getOtherPleadingTypeDesc()}} <br>
                             {{otherAllegation.getOtherPleadingDate()}} {{otherAllegation.getOtherPleadingTime()}}</td>
                           <td id="{{'juvenile-caseDetails-dispositionDelinquentOffense-' + i + '-allegationDescription'}}">
                             {{otherAllegation.getOtherAllegationDescription()}} <br>        
                             {{otherAllegation.getOtherAllegationOffenseDate()}}</td>
                         </tr>    
                        </tbody>
                    </table>
                </div>
            </div>
            </div>
     <div class="panel panel-default">
             <div class="panel-title">
               Order
             </div>
             <div class="panel-body">
               <span>Level 3 Disposition information is not available in JWISE at this time.</span>
             </div>
         </div>
   </div>
  </div>


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/juvenile/allegations/allegations-additional-info/disposition-delinquent-offense/disposition-delinquent-offense.component.html